import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { saveRiskAnalysisMatrix } from "@/api/endpoints/riskAnalysis";
import type {
  SaveRiskAnalysisMatrixRequest,
  SaveRiskAnalysisMatrixResponse,
} from "@/types/risk-analysis";

export function useSaveRiskAnalysisMatrix(): UseMutationResult<
  SaveRiskAnalysisMatrixResponse,
  Error,
  SaveRiskAnalysisMatrixRequest,
  unknown
> {
  return useMutation({
    mutationFn: saveRiskAnalysisMatrix,
  });
}
